import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import AccessSlice from './Slicer/AccessSlice';
import ManageAdminSlicer from './Slicer/ManageAdminSlicer';
import CustomerSlicer from './Slicer/CustomerSlicer';
import CustomerBillRetrieve from './Slicer/CustomerBillRetrieve';
import PayBillsData from './Slicer/PayBillsData';
import PGslice from './Slicer/PGSlice';
import accountandBliingSlice from './Slicer/accountandBliingSlice';
import UserSlice from './Slicer/UserSlice';
import GroupAdmin from './Slicer/GroupAdmin';
import viewDetailBulk from './Slicer/viewDetailBulk';
import OrderinfoBulk from './Slicer/OrderinfoBulk'
const reducers = combineReducers({
  GetAccess: AccessSlice,
  ManageAdmin: ManageAdminSlicer,
  GetCustomer: CustomerSlicer,
  GetCustBillData: CustomerBillRetrieve,
  GetPayBillsData: PayBillsData,
  accountAndBilling: accountandBliingSlice,
  pg: PGslice,
  user: UserSlice,
  GetCount: GroupAdmin,
  getViewDetailBulk: viewDetailBulk,
  getBulkOrderData:OrderinfoBulk,
});
const persistConfig = {
  key: 'root',
  storage,
};
const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export default store;
